<template>
  <div class="home">
    <div class="menu">
      <div class="logo" />
      <Menu ref="menu"></Menu>
    </div>
    <div class="content">
      <Header></Header>
      <div class="main-wrap">
        <keep-alive>
          <router-view class="flex main" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="flex main" v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Menu from "@/components/Menu.vue";

export default {
  name: "Home",
  data() {
    return {
      nav: [],
    };
  },
  mounted() {
    this.nav = this.$router;
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
  components: { Menu, Header },
};
</script>

<style scoped lang="scss">
.home {
  height: 100%;
  display: flex;
  flex: 1;
  overflow: hidden;
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;

    .main-wrap {
      display: flex;
      flex: 1;
      flex-direction: column;
      overflow: hidden;
      background-color: #fafafa;
      padding: 10px;
    }

    .main {
      padding: 15px 15px 6px;
      flex: 1;
      display: flex;
      overflow: hidden;
      background-color: #fff;
    }
  }
  .menu {
    background-color: #001529;
    display: flex;
    flex-direction: column;
    width: 176px;
    .logo {
      height: 64px;
      background: url("../../src/assets/img/project-icon.png") no-repeat center center;
      background-size: 79%;
    }
  }

}
</style>
